import React, { FC } from 'react';
import styles from './password-requirements.module.css';

import { checkPasswordRules } from '../../helpers/validate-helper';

const PasswordRequirements: FC<{ password: string }> = ({ password }) => {
  const rules = checkPasswordRules(password);

  return (
    <ul className={styles.requirementList}>
      {rules.map((rule) => (
        <li
          key={rule.id}
          className={rule.met ? styles.requirementMet : styles.requirementUnmet}
        >
          <span aria-hidden='true' className={styles.marker}>
            {rule.met ? '✓' : '○'}
          </span>
          {rule.label}
        </li>
      ))}
    </ul>
  );
};

export default PasswordRequirements;
